import { isEmpty } from "lodash";
import { authHelpers, generalHelpers } from ".";

export const validateUsername = (username) => {
  //"Username should contain only alphanumeric characters",
  const usernameRegex = /^[a-zA-Z0-9]+$/;
  return username.match(usernameRegex)
    ? ""
    : "Username should contain only alphanumeric characters";
};

export const validateFirstName = (firstName) => {
  // Check if firstName is a non-empty string
  if (typeof firstName !== "string" || firstName.trim().length === 0) {
    return "First name must be a non-empty string";
  }
  return "";
};

export const validateLastName = (lastName) => {
  // Check if lastName is a non-empty string
  if (typeof lastName !== "string" || lastName.trim().length === 0) {
    return "Last name must be a non-empty string";
  }
  return "";
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[0-9]{9}$/;
  return phone.match(phoneRegex) ? "" : "Enter valid phone number";
};

export const validatePersonalAddress = (address) => {
  // Check if address is a non-empty string
  if (isEmpty(address)) {
    return "Address must be a non-empty string";
  }
  return "";
};

export const validateCountry = (country) => {
  // Check if country is a non-empty string
  if (typeof country !== "string" || country.trim().length === 0) {
    return "Country must be a non-empty string";
  }
  return "";
};

export const validateOccupation = (occupation) => {
  if (typeof occupation !== "string" || occupation.trim().length === 0) {
    return " Occupation must be a non-empty string";
  }
  return "";
};

export const validateNationalNo = (nationalNo) => {
  // must be 9 digits
  const nationalNoRegex = /^[0-9]{9}$/;
  return nationalNo.match(nationalNoRegex) ? "" : "Enter valid national number";
};

export const validateStageName = (stageName) => {
  //not empty // Check if  is a non-empty string
  if (typeof stageName !== "string" || stageName.trim().length === 0) {
    return "Stage name must be a non-empty string";
  }
  return "";
};

export const validateDescription = (description) => {
  // Check if description is a non-empty string
  if (isEmpty(description)) {
    return "Business description must be a non-empty string";
  }
  return "";
};

//check the business name is empty or not
export const validateBusinessName = (businessName) => {
  if (isEmpty(businessName)) {
    return "Business name must be a non-empty string";
  }
  return "";
};

export const otherOption = (businessName) => {
  if (isEmpty(businessName)) {
    return " Occupation is required";
  }
  return "";
};

export const validateAddress = (address) => {
  // Check if address is a non-empty string
  if (isEmpty(address)) {
    return "Business Address name must be a non-empty string";
  }
  return "";
};

export const validateCity = (city) => {
  if (isEmpty(city)) {
    return "City must be a non-empty string";
  }
  return "";
};

export const validateDate = (date) => {
  if (!date) {
    return;
  }

  const today = new Date();
  const birthDate = new Date(date);

  const age = today.getFullYear() - birthDate.getFullYear();

  if (age < 18 || (age === 18 && today.getMonth() < birthDate.getMonth())) {
    return "You must be at least 18 years old";
  }

  return "";
};

//convert date to 20, Feb 2023 this formate
export const convertDate = (date) => {
  const d = new Date(date);
  const month = d.toLocaleString("default", { month: "short" });
  return `${d.getDate()}, ${month} ${d.getFullYear()}`;
};

//convert timestamp duration to min and sec
export const convertDuration = (duration) => {
  const min = Math.floor(duration / 60);
  const sec = duration % 60;
  return `${min}:${sec}`;
};

export const PersonalInfoPayload = (data) => {
  const payload = {
    first_name: data.first_name,
    last_name: data.last_name,
    country: data.country,
    birthday: data.birthday,
    national_identity_no: data.national_identity_no,
    stage_name: data.stage_name,
    description: data.description,
    profile_img: data.profile_img,
    profile_img_url: data.profile_img,
    username: data.username,
  };
  return payload;
};

export const BankInfoPayload = (data) => {
  const payload = {
    bank_name: data.bank_name,
    acc_no: data.acc_no,
    acc_holder_name: data.acc_holder_name,
    cin_no: data.cin_no,
    iban: data.iban,
    swift_code: data.swift_code,
    branch_code: data.branch_code,
  };
  return payload;
};

export const validateName = (name) => {
  if (typeof name !== "string" || name.trim().length === 0) {
    return "Name must be a non-empty string";
  }
  return "";
};

export const validateUsernameOrEmail = (usernameOrEmail) => {
  if (
    typeof usernameOrEmail !== "string" ||
    usernameOrEmail.trim().length === 0
  ) {
    return "Username or email must be a non-empty string";
  }
  return "";
};
